/**
 *  Modal script file
**/

export default {
  name: 'Modal',
  mixins: [],
  components: {},
  props: {
    backgroundClose: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {}
  },
  computed: {
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
